import React, { useState, useEffect } from 'react';

const StickyHeader = ({ name, brandColor, bookingUrl }) => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-40 transition-all duration-300 ${
        isScrolled ? 'py-3 bg-gray-900/80 backdrop-blur-md shadow-lg border-b border-white/10' : 'py-5 bg-transparent'
      }`}
    >
      <div className="max-w-6xl mx-auto px-6 flex items-center justify-between">
        <h2 className="text-white font-bold text-xl tracking-tight">{name}</h2>
        <button
          onClick={() => window.location.href = bookingUrl}
          className={`px-5 py-2 rounded-full font-bold text-sm transition-all text-white shadow-md hover:shadow-lg ${
            isScrolled ? 'opacity-100 scale-100' : 'opacity-0 scale-90 pointer-events-none'
          }`}
          style={{ backgroundColor: brandColor }}
        >
          Agendar Cita
        </button>
      </div>
    </nav>
  );
};

export default StickyHeader;
